import HeroForm from "./HeroForm";
import type { HeroFormAdapterProps } from "./HeroForm.d";

export { HeroForm };
export type { HeroFormAdapterProps };
